import {createTheme} from '@mui/material/styles';


const theme = createTheme({
    palette:{
        primary:{
            "main":'#F857A6',
        },
        secondary:{
            main:"#FF5858"
        },
        background:{
            default:'#FFF'
        }
    },
    typography:{
        fontFamily:''
    }
})

export default theme;